<script setup lang="ts">
import { ref, watch } from 'vue';
import Notification from '@/components/Base/Notification/Notification.vue';
import { useGlobalError } from '@/composables/useGlobalError';

const { globalError, clearError } = useGlobalError();

const showError = ref(false);

watch(globalError, (val) => {
  showError.value = !!val;
});
const closeError = () => {
  showError.value = false;
  globalError.value = null;
  clearError();
};
</script>

<template>
  <Notification
    v-if="showError && globalError"
    :options="{ duration: 0 }"
    class="flex items-center bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
  >
    <div class="flex-1">{{ globalError }}</div>
    <button type="button" class="absolute top-0 bottom-0 right-0 px-4 py-3 text-red-700 font-bold" @click="closeError" aria-label="Close">×</button>
  </Notification>
</template>
